<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small ">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            Learn what we are about and where we are from
            <br>
            &lt;!&ndash;<span class="uk-text-small uk-text-muted">
                Late Applicant will be considered but will attract late fees.
              </span>&ndash;&gt;
            &lt;!&ndash;<br><br>
            <a href="#" class="uk-button uk-button-default">Learn More</a>&ndash;&gt;
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class=" uk-text-center specHeading"><span>About Northern Caribbean University</span></h1>

        <div class="uk-container uk-container-small">

          <p>
            Northern Caribbean University (NCU) is a private, liberal-arts institution, located in Jamaica,
            that is owned and operated by the Jamaica Union Conference and the Atlantic Caribbean Union Mission
            of Seventh-day Adventists (comprising the territories the Bahamas, Cayman Islands and the Turks and
            Caicos Islands). With its main campus only 2 miles south of the town of Mandeville, in Manchester,
            and three regional campuses situated in Kingston, Montego Bay and St. Ann, this university offers a
            number of professional, pre-professional and vocational programmes in a spiritually wholesome and
            aesthetically pleasing atmosphere.
          </p>
          <p>
            NCU operates in harmony with the beliefs, practices and educational philosophy of the Seventh-day Adventist Church.
            As such, it encourages students to relate their academic pursuits to their understanding of the Christian faith.
            It emphasizes the development of a sound Christian character and seeks to maintain an atmosphere, which fosters
            in its students, commitment and growth in a personal relationship with Jesus Christ. Thus, faith and learning
            combine to prepare students for practical Christian usefulness.
          </p>
          <p>
            In their conduct and dealings, faculty, staff and students alike must comply with the standards set by the institution in keeping with our Seventh-day Adventist beliefs.

            For more information about Seventh-day Adventist beliefs, visit http://www.adventist.org
          </p>
        </div>
      </div>
      <div class="uk-background-muted uk-padding">
        <h1 class="uk-heading-line uk-text-center specHeading"><span>History of the Northern Caribbean University</span></h1>
        <div class="uk-container uk-container-small">


          <div class="uk-child-width-1-2@l" uk-grid>
            <div>
              <img class="uk-responsive-width uk-responsive-height uk-align-center" src="../assets/circleofknowledge.jpg" alt="">
            </div>
            <div>
              <p>
                <br>
                Northern Caribbean University is the oldest private tertiary institution in Jamaica.
                <br><br>
                Founded in 1907 the institution started with only 8 students. It operated as the West Indian Training School in Riversdale, St. Catherine and at first only offered courses up to the twelfth grade.
                The school moved to its current location near Mandeville, Manchester in 1919.  As its offerings developed to include theology, teaching, secretarial science, business, and natural sciences, it became a junior college and was then called the West Indian Training College.
                <br><br>
              </p>
            </div>
          </div>
          <div>
            <br>
            It achieved senior college status in the late 1950's when it began to offer the Bachelor's degree in Theology and was known as West Indies College. Since then, baccalaureate programmes in some twenty other disciplines have been added.
            The college was granted university status in 1999 by the Jamaican Government and the school became Northern Caribbean University. Presently the university offers over seventy degree programmes, (several of which are graduate programmes) in the sciences, business and education.

          </div>
        </div>
      </div>
      <div class="uk-padding  ">
        <div class="uk-container uk-container-small ">
          <h2 class="uk-heading-line specHeading uk-text-center"><span>Alma Mater</span></h2>
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <h4 class="uk-heading-bullet specHeading">Word: Herbert John Thompson</h4>
              <h4 class="uk-heading-bullet uk-margin-remove-top specHeading">Song: Daniel Rodriquez</h4>
              <p class="uk-text-center">To the blessed hill you brought us <br>

                Where we've had our hopes and dreams fulfilled.
                <br>
                Oh the glorious things you taught us
                <br>
                'Midst the pine trees and the wind
                <br>
                We will rise and  call you blessed
                <br>
                As we strive to serve mankind.
                <br>
                And we'll praise our God each moment
                <br>
                For the love in you we find.
                <br>
                And we'll praise our God each moment
                <br>
                For the love in you we find.</p>
              <p class="uk-text-center">Chorus</p>
              <p class="uk-text-center">
                Oh dear beacon on the hill
                <br>
                A bastion so true
                <br>
                We pledge our love and loyalty
                <br>
                In gratitude to you.
                <br>
                March onward ever upward, ever forward
                <br>
                Alma Mater, NCU
              </p>
            </div>
            <div>
              <div class="video-responsive">
              <iframe style="width:100%;height:100%;" src="https://www.youtube.com/embed/GKM0ULyS8ZQ" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </transition>

</template>

<script>

  export default {
        name: "ncuweare",
        components: {

        },
        mounted(){
          window.scrollTo(0, 0);
        },
  metaInfo: {
    // Children can override the title.
    title: 'NCU About Us',
      // Result: My Page Title ← My Site
      // If a child changes the title to "My Other Page Title",
      // it will become: My Other Page Title ← My Site
      //titleTemplate: '%s ← My Site',
      // Define meta tags here.
      meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'What are the core values of Northern Caribbean University '}
    ]
  }
    }
</script>

<style scoped>
  .video-responsive{
    overflow:hidden;
    padding-bottom:76.25%;
    position:relative;
    height:0;

  }
  .video-responsive iframe{
    left:0;
    top:0;
    height:100%;
    width:100%;
    position:absolute;
  }
  @media screen and (max-width:600px){


    h1{
      font-size: 1.4em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
